import { Settings, QrCode, UserPlus, UserMinus, Zap, Send } from 'lucide-react'
import { useAdmin } from '../../contexts/AdminContext'
import { useAuth } from '../../contexts/AuthContext'

interface ProfileActionsProps {
    isOwnProfile: boolean
    isFollowing: boolean
    isFollowLoading: boolean
    onEdit: () => void
    onQR: () => void
    onFollow: () => void
    onZap: () => void
    onMessage: () => void
}

export function ProfileActions({
    isOwnProfile,
    isFollowing,
    isFollowLoading,
    onEdit,
    onQR,
    onFollow,
    onZap,
    onMessage
}: ProfileActionsProps) {
    const { settings } = useAdmin()
    const { isAdmin } = useAuth()
    const canEdit = settings.features.profileEditing || isAdmin
    const canZap = settings.features.zapsEnabled || isAdmin

    return (
        <div className="flex gap-2 mt-4">
            {isOwnProfile ? (
                <>
                    {canEdit && (
                        <button
                            onClick={onEdit}
                            className="flex items-center justify-center gap-2 px-4 py-2 bg-surface-50 dark:bg-surface-800 hover:bg-surface-100 dark:hover:bg-surface-700 text-gray-700 dark:text-gray-300 rounded-xl transition-colors border border-surface-200 dark:border-surface-600 font-poppins font-bold text-sm"
                        >
                            <Settings className="w-4 h-4" />
                            <span className="hidden md:inline">Düzenle</span>
                        </button>
                    )}
                    <button
                        onClick={onQR}
                        className="flex items-center justify-center gap-2 px-4 py-2 bg-white dark:bg-surface-900 hover:bg-surface-50 dark:hover:bg-surface-800 text-gray-700 dark:text-gray-300 rounded-xl transition-all border border-surface-200 dark:border-surface-700 font-poppins font-bold text-sm"
                    >
                        <QrCode className="w-4 h-4" />
                    </button>
                </>
            ) : (
                <>
                    {canZap && (
                        <button
                            onClick={onZap}
                            className="flex items-center justify-center gap-2 px-4 py-2 bg-white dark:bg-surface-900 hover:bg-surface-50 dark:hover:bg-surface-800 text-gray-700 dark:text-gray-300 rounded-xl transition-all border border-surface-200 dark:border-surface-700 font-poppins font-bold text-sm"
                        >
                            <Zap className="w-4 h-4" />
                        </button>
                    )}
                    <button
                        onClick={onFollow}
                        disabled={isFollowLoading}
                        className={`flex items-center justify-center gap-2 px-4 py-2 rounded-xl transition-all border font-poppins font-bold text-sm ${isFollowing
                            ? 'bg-surface-50 dark:bg-surface-800 hover:bg-surface-100 dark:hover:bg-surface-700 text-gray-700 dark:text-gray-300 border-surface-200 dark:border-surface-600'
                            : 'bg-mavi-500 hover:bg-mavi-600 text-white border-mavi-600 shadow-lg shadow-mavi-500/20'
                            } ${isFollowLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
                    >
                        {isFollowing ? (
                            <>
                                <UserMinus className="w-4 h-4" />
                                <span className="hidden md:inline">Takipten Çık</span>
                            </>
                        ) : (
                            <>
                                <UserPlus className="w-4 h-4" />
                                <span className="hidden md:inline">Takip Et</span>
                            </>
                        )}
                    </button>
                    <button
                        onClick={onMessage}
                        className="flex items-center justify-center gap-2 px-4 py-2 bg-mavi-500 hover:bg-mavi-600 text-white rounded-xl transition-colors font-poppins font-bold text-sm shadow-lg shadow-mavi-500/20"
                    >
                        <Send className="w-4 h-4" />
                        <span className="hidden md:inline">Mesaj</span>
                    </button>
                </>
            )}
        </div>
    )
}
